/**
 * Indicates that one or more required input parameters are missing.
 */
export default class MissingInputError extends Error
{
    /** @type {string[]} */
    params;

    /**
     * Construct a new MissingInputError object.
     *
     * @param {string|string[]} params The codes of the missing parameters.
     */
    constructor(params)
    {
        if(!Array.isArray(params))
        {
            params = [params];
        }

        for(let i = 0; i < params.length; i++)
        {
            const t = typeof params[i];
            if(t !== 'string')
            {
                throw new TypeError(`params[${i}] must be a string; ${t} given`);
            }
        }

        let message = 'Missing input';
        if(params.length > 1)
        {
            message += 's';
        }
        message += ': ' + params.join(', ');

        super(message);
        this.params = params.slice();
    }

    /**
     * Get the codes of the missing input parameters.
     *
     * @returns {string[]}
     */
    getParams()
    {
        return this.params.slice();
    }
}
